export default __webpack_public_path__ + "img/logo-nspa.0a79514.svg";